import {PlanningScope} from '@widgets/planning-time-controls'

/**
 * Path segments for the production-planning feature's sub-routes (daily / monthly views).
 *
 * The values intentionally mirror {@link PlanningScope} so a selected planning scope maps
 * one-to-one to a route segment. Keeping this feature-local removes the dependency on the
 * legacy `hcem` routing module and lets the feature be mounted under any parent route
 * (e.g. Suite) without hardcoded absolute paths.
 */
export enum RouteSegment {
  DAILY = 'daily',
  MONTHLY = 'monthly'
}

/**
 * Resolves the relative route segment for a given planning scope, used to navigate
 * between the daily and monthly production-planning views.
 */
export const getRouteSegmentForScope = (scope: PlanningScope): RouteSegment =>
  scope === PlanningScope.Daily ? RouteSegment.DAILY : RouteSegment.MONTHLY
